import { useRef, useCallback } from "react";
import { Bold, Italic, List, ListOrdered, Link, Image, Video, Quote, Heading1, Heading2, Undo } from "lucide-react";

export const RichEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);

  const exec = useCallback((cmd, val = null) => {
    document.execCommand(cmd, false, val);
    if (editorRef.current) onChange(editorRef.current.innerHTML);
  }, [onChange]);

  const insertLink = () => {
    const url = prompt("URL del enlace:");
    if (url) exec("createLink", url);
  };

  const insertImage = () => {
    const url = prompt("URL de la imagen:");
    if (url) exec("insertHTML", `<img src="${url}" alt="" style="max-width:100%;border-radius:12px;margin:12px 0" />`);
  };

  const insertVideo = () => {
    const url = prompt("URL del vídeo (YouTube o TikTok):");
    if (!url) return;
    let embedUrl = url;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
    if (ytMatch) embedUrl = `https://www.youtube.com/embed/${ytMatch[1]}`;
    const ttMatch = url.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
    if (ttMatch) embedUrl = `https://www.tiktok.com/embed/v2/${ttMatch[1]}`;
    exec("insertHTML", `<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;aspect-ratio:16/9;border-radius:12px;margin:12px 0"></iframe>`);
  };

  const ToolBtn = ({ onClick, children, title }) => (
    <button type="button" onClick={onClick} title={title}
      className="p-1.5 rounded hover:bg-[#333] text-[#8A8A8D] hover:text-white transition-colors">
      {children}
    </button>
  );

  return (
    <div className="border border-[rgba(138,138,141,0.2)] rounded-xl overflow-hidden">
      <div className="flex flex-wrap gap-0.5 p-2 bg-[#111] border-b border-[rgba(138,138,141,0.15)]">
        <ToolBtn onClick={() => exec("formatBlock", "h2")} title="Título"><Heading1 className="w-4 h-4" /></ToolBtn>
        <ToolBtn onClick={() => exec("formatBlock", "h3")} title="Subtítulo"><Heading2 className="w-4 h-4" /></ToolBtn>
        <div className="w-px bg-[#333] mx-1" />
        <ToolBtn onClick={() => exec("bold")} title="Negrita"><Bold className="w-4 h-4" /></ToolBtn>
        <ToolBtn onClick={() => exec("italic")} title="Cursiva"><Italic className="w-4 h-4" /></ToolBtn>
        <div className="w-px bg-[#333] mx-1" />
        <ToolBtn onClick={() => exec("insertUnorderedList")} title="Lista"><List className="w-4 h-4" /></ToolBtn>
        <ToolBtn onClick={() => exec("insertOrderedList")} title="Lista numerada"><ListOrdered className="w-4 h-4" /></ToolBtn>
        <ToolBtn onClick={() => exec("formatBlock", "blockquote")} title="Cita"><Quote className="w-4 h-4" /></ToolBtn>
        <div className="w-px bg-[#333] mx-1" />
        <ToolBtn onClick={insertLink} title="Enlace"><Link className="w-4 h-4" /></ToolBtn>
        <ToolBtn onClick={insertImage} title="Imagen"><Image className="w-4 h-4" /></ToolBtn>
        <ToolBtn onClick={insertVideo} title="Vídeo"><Video className="w-4 h-4" /></ToolBtn>
        <div className="w-px bg-[#333] mx-1" />
        <ToolBtn onClick={() => exec("removeFormat")} title="Limpiar formato"><Undo className="w-4 h-4" /></ToolBtn>
      </div>
      <div
        ref={editorRef}
        contentEditable
        className="min-h-[250px] p-4 text-[#C4C4C6] focus:outline-none blog-content"
        onInput={() => { if (editorRef.current) onChange(editorRef.current.innerHTML); }}
        dangerouslySetInnerHTML={{ __html: value }}
        data-testid="blog-editor"
      />
    </div>
  );
};
